// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__eLmmv","pending":"notification_pending__MiTbw","success":"notification_success__vn4Rh","error":"notification_error__J6mI0"};